import React from 'react';

import { localeDetails } from '~/components/CmsMain/localeGlobals';
import { StateFieldFormik } from '~/components/GlobalLossLocation';
import { JURISDICTION_INFORMATION_FIELDS } from '~/components/LegalActions/FormFragments/FormFieldsDefinitions';
import TextFieldFormik, { DatePickerTextFieldFormik } from '~/components/TextFieldFormik';

export const JurisdictionInformationForm = () => {
  return (
    <>
      <div className="flex w-full gap-32">
        {/* Unlike the other StateFieldFormik usages (direct children of a CSS grid that
            stretches them), this field sits in a flex cell, so the inline-block autocomplete
            keeps its intrinsic width — stretch the rendered field to fill the half-column. */}
        <div className="flex w-1/2 [&>*]:w-full">
          <StateFieldFormik
            id={JURISDICTION_INFORMATION_FIELDS.jurisdiction.key}
            label={JURISDICTION_INFORMATION_FIELDS.jurisdiction.label}
            country={localeDetails.locale.region}
            hideForCountriesWithoutStates
          />
        </div>
        <div className="flex w-1/2">
          <TextFieldFormik
            id={JURISDICTION_INFORMATION_FIELDS.venue.key}
            label={JURISDICTION_INFORMATION_FIELDS.venue.label}
            fullWidth
          />
        </div>
      </div>
      <div className="flex w-full gap-32">
        <div className="flex w-1/2">
          <TextFieldFormik
            id={JURISDICTION_INFORMATION_FIELDS.court.key}
            label={JURISDICTION_INFORMATION_FIELDS.court.label}
            fullWidth
          />
        </div>
        <div className="flex w-1/2">
          <DatePickerTextFieldFormik
            containerClassName="w-full"
            fullWidth
            id={JURISDICTION_INFORMATION_FIELDS.dateFilledInCourt.key}
            label={JURISDICTION_INFORMATION_FIELDS.dateFilledInCourt.label}
            nullIfEmpty
          />
        </div>
      </div>
    </>
  );
};
